// extracted by mini-css-extract-plugin
export default {"pre-order-message":"DTPmBm","preOrderMessage":"DTPmBm"};